module.exports = __webpack_public_path__ + "img/tajikistan.696378aa.svg";